export default function CTASection() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto text-center">
        <p className="font-heading text-xs md:text-sm uppercase tracking-widest text-accent-600 font-semibold mb-3">
          Start Shopping Smarter
        </p>
        <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900 mb-4 leading-tight">
          Ready to Explore the Sugargoo Spreadsheet?
        </h2>
        <p className="text-foreground-600 text-sm md:text-base mb-8 max-w-xl mx-auto leading-relaxed">
          Jump into the most organized product research database available. Browse categories, compare products, and discover trending finds — all in one place.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 rounded-full bg-primary-500 text-white font-semibold text-sm md:text-base hover:bg-primary-600 transition-all whitespace-nowrap"
          >
            Sugargoo Spreadsheet
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 rounded-full border-2 border-foreground-300 text-foreground-700 font-semibold text-sm md:text-base hover:border-primary-400 hover:text-primary-600 transition-all whitespace-nowrap"
          >
            Buy It Now
          </a>
        </div>
      </div>
    </section>
  );
}